module.exports = __webpack_public_path__ + "img/service-01-pic-7.80ce1146.png";